import type { FieldMetaConfig, Preset, Tool } from './types'

export const DEFAULT_FIELD = {
	pageNumber: 1,
	pageX: 15,
	pageY: 70,
	pageWidth: 30,
	pageHeight: 8,
}

export const TOOL_COLORS: Record<Tool, string> = {
	SIGNATURE: '#2563eb',
	INITIALS: '#0d9488',
	NAME: '#7c3aed',
	TITLE: '#d97706',
	COMPANY: '#059669',
	EMAIL: '#0284c7',
	PHONE: '#ea580c',
	DATE: '#e11d48',
	ADDRESS: '#4f46e5',
	CUSTOM: '#475569',
}

export const PREVIEW_PAGE_WIDTH_PX = 820
export const PREVIEW_FALLBACK_PAGE_HEIGHT_PX = 1160
export const INLINE_FIELD_FONT_SIZE_PX = 14
export const INLINE_FIELD_LINE_HEIGHT_PX = 18
export const INLINE_FIELD_HORIZONTAL_PADDING_PX = 16
export const INLINE_FIELD_VERTICAL_PADDING_PX = 12

const FIELD_META_BY_KEY: Record<Preset, FieldMetaConfig> = {
	INITIALS: {
		label: 'Initials',
		placeholder: 'A. B.',
		required: true,
	},
	NAME: {
		label: 'Full name',
		placeholder: 'Jane Doe',
		required: true,
		characterLimit: 100,
	},
	EMAIL: {
		label: 'Email',
		placeholder: 'name@domain',
		required: true,
		characterLimit: 120,
	},
	PHONE: {
		label: 'Phone',
		placeholder: '+1 (555) 123-4567',
		required: false,
		characterLimit: 32,
	},
	COMPANY: {
		label: 'Company',
		placeholder: 'Acme Inc.',
		required: false,
		characterLimit: 80,
	},
	TITLE: {
		label: 'Title',
		placeholder: 'Software Engineer',
		required: false,
		characterLimit: 80,
	},
	DATE: {
		label: 'Date',
		placeholder: 'YYYY-MM-DD',
		required: false,
		characterLimit: 20,
	},
	ADDRESS: {
		label: 'Address',
		placeholder: '123 Main St',
		required: false,
		characterLimit: 200,
	},
	CUSTOM: {
		label: 'Text',
		placeholder: 'Enter text',
		required: false,
		characterLimit: 200,
	},
}

export const PRESET_META: Record<Preset, FieldMetaConfig> = {
	NAME: FIELD_META_BY_KEY.NAME,
	EMAIL: FIELD_META_BY_KEY.EMAIL,
	PHONE: FIELD_META_BY_KEY.PHONE,
	COMPANY: FIELD_META_BY_KEY.COMPANY,
	TITLE: FIELD_META_BY_KEY.TITLE,
	DATE: FIELD_META_BY_KEY.DATE,
	ADDRESS: FIELD_META_BY_KEY.ADDRESS,
	CUSTOM: FIELD_META_BY_KEY.CUSTOM,
	INITIALS: FIELD_META_BY_KEY.INITIALS,
}

export const INITIALS_META = FIELD_META_BY_KEY.INITIALS

export { FIELD_META_BY_KEY }
